import { SelectValue } from '../../../Components/Base/Select/Select';
import { DocumentContentSubType } from '../../Documents/Enums/documentContentSubType.enum';

export const remapDiagnosisValues = (diagnoses: SelectValue[]) => {
	if (diagnoses.length) {
		return diagnoses?.map((item: any, index: number) => {
			return {
				subType:
					index < 1
						? DocumentContentSubType.MAIN_DIAGNOSIS
						: DocumentContentSubType.SECONDARY_DIAGNOSIS,
				...item.diagnose,
			};
		});
	}
	return [];
};
